export function getCookieValue(name: string) {
  return (
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  );
}

export function setCookie({
  name,
  value,
  domain = '.sisal.it',
  expires,
  path = '/',
}: {
  name: string;
  value: string | number | boolean;
  domain?: string;
  expires?: string;
  path?: string;
}) {
  document.cookie = `${name}=${value};${expires ? `expires=${expires};` : ''}${
    domain ? `domain=${domain};` : ''
  }${path ? `path=${path};` : ''}`;
}

export function clearCookie(name: string, domain = '.sisal.it', path = '/') {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=${path};`;
}
